<template>
  <div>
    <nav
      id="nav-menu"
      class="fixed-bottom py-0 d-flex justify-content-around mt-2"
      style="background: rgb(162, 162, 162); overflow-x: auto; white-space: nowrap"
    >
      <div
        :style="mtdGetStyle('compras')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('compras')"
      >
        <span :style="mtdGetStyleSpan('compras')" class="btn w-100"
          ><strong>COMPRAS</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('stock')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('stock')"
      >
        <span :style="mtdGetStyleSpan('stock')" class="btn w-100"
          ><strong>STOCK</strong></span
        >
      </div>
      <div
        :style="mtdGetStyle('lisCompras')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('lisCompras')"
      >
        <span :style="mtdGetStyleSpan('lisCompras')" class="btn w-100"
          ><strong>LISTADO DE COMPRAS</strong></span
        >
      </div>
      <!-- <div
        :style="mtdGetStyle('requerimiento')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('requerimiento')"
      >
        <span :style="mtdGetStyleSpan('requerimiento')" class="btn w-100"
          ><strong>REQUERIMIENTOS</strong></span
        >
      </div> -->
      <div
        :style="mtdGetStyle('productos')"
        class="navbar-brand pl-2 text-white text-center pr-2 nav-footer w-100 border-end border-white border"
        @click="mtdSendOption('productos')"
      >
        <span :style="mtdGetStyleSpan('productos')" class="btn w-100"
          ><strong>MANTENIMIENTO</strong></span
        >
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "NavBarComponent",
  props: {
    pageView: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      page: null,
    };
  },
  created() {},
  methods: {
    mtdGetStyle: function (option) {
      if (option == this.page && this.pageView != "home" && this.pageView != "close")
        return "background: #2f395c";
      return "";
    },
    mtdGetStyleSpan: function (option) {
      if (option == this.page && this.pageView !== "home" && this.pageView !== "close")
        return "color:white";
      return "text-dark";
    },
    mtdSendOption: function (page) {
      this.page = page;
      this.$emit("changePage", this.page);
    },
  },
};
</script>